import { RoutesData } from './routes/routes';
import { Route, Routes } from 'react-router';
import Layout from './components/layout/Layout';


export default function App() {

    return (
        <Layout>
            <Routes>
                {Object.keys(RoutesData).map((key: string) =>
                    <Route
                        key={key}
                        path={RoutesData[key].path}
                        element={RoutesData[key].component}
                    />,
                )}
            </Routes>
        </Layout>
    );
}

